export default {
    ingredients: [],
  }